import { SeamlessLogger } from './logger';
import { Logger, StatusType } from '@datadog/browser-logs';
import { Logger as WinstonLogger } from 'winston';
/**
 * type for the config object regarding logger
 * @field debugNamespaces array of namespaces to enable debug mode
 */
export type LoggerConfig = { debugNamespaces: string[] };

/**
 * enum for the aem environment Stage Variants
 *
 * @ignore
 */
export enum StageVariants {
  dev = 'dev',
  test = 'test',
  int = 'int',
  pprod = 'pprod',
  prod = 'prod',
}

/**
 * type for the methods provided by the namespaced SeamlessLogger instance
 *
 * @ignore
 */
export type NamespacedLogger = {
  logger?: WinstonLogger | Logger;
  log: ConsoleFunction | DisabledConsoleMethod;
  error: ConsoleFunction;
  warn: ConsoleFunction | DisabledConsoleMethod;
  debug: ConsoleFunction | DisabledConsoleMethod;
  table: ConsoleFunction | DisabledConsoleMethod;
  clear: () => void;
  version: string;
};

/**
 * type for the logging methods that are exposed to the user. The user can pass whatever he wishes to be
 * logged.
 *
 * @ignore
 */
export type ConsoleFunction = (...args: unknown[]) => void;
export type DisabledConsoleMethod = () => void;

/**
 * type for the config object regarding each logger namespace
 * @field color each namespace has a color associated to better differentiate each logging
 * @field isDebugEnabled allows this namespace to log every log level in production
 */
export type NamespaceConfig = { color: string; isDebugEnabled: boolean; hasAllowedDatadogTenant?: boolean };

/**
 * type for the console methods supported
 */
export type ConsoleMethods = keyof Console;

/**
 * type for the logger object that will live on the window.
 *
 * we are providing the instance and the initializeLogger in order to ensure that the
 * seamless logger can be externalized.
 */
export type SeamlessLoggerProvider = {
  seamlessLoggerInstance: SeamlessLogger;
  initializeLogger: (namespace?: string) => NamespacedLogger;
};

/**
 * Type for the config object regarding datadog
 */
export type DatadogConfig = {
  tenant: string;
  level?: StatusType;
  configs?: { [key: string]: string };
};

export interface DatadogLoggerArgs {
  message?: any;
  messageContext?: object;
  error?: Error;
}

export type CreateLoggerParams = {
  version?: string;
  datadogService?: string;
  loggerContext: Record<string, unknown>;
  namespace: string;
  level?: StatusType;
};
